import React from 'react';
import { useState, useEffect } from 'react';

import { Carousel } from 'react-bootstrap';
import './carousel.css'
// import 'bootstrap/dist/css/bootstrap.min.css';
import carousel1 from '../img/carousel-1.jpg'
import carousel2 from '../img/carousel-2.jpg'
import oa_logo from '../img/OA_logo_carousel1.jpg'
import PriceScroller from "../components/pricescroll";
import VideoModal from "../components/ui/video";

function HeaderCarousel() {
  const [showVideo, setShowVideo] = useState(false);
  const [firstTimeOpen, setFirstTimeOpen] = useState(true);

  const handleOpenVideo = () => setShowVideo(true);
  const handleCloseVideo = () => setShowVideo(false);

  // Auto-open on first page load
  useEffect(() => {
    if (firstTimeOpen) {
      setShowVideo(true);
      setFirstTimeOpen(false);
    }
  }, [firstTimeOpen]);

    return (
        <Carousel >
            <Carousel.Item style={{height:"550px"}}>
                      <div className="carousel-image-wrapper">

              <img src={oa_logo}  className="img-fluid w-100" alt="Image"/>
	    <div className="overlay"></div> {/* Overlay div */}
        </div>
                <Carousel.Caption>
                      <div className="container">
                          <div className="row gy-0 gx-5">
                              <div className="col-lg-0 col-xl-5"></div>
                              <div className="col-xl-7 animated fadeInLeft">
                                  <div className="text-sm-center text-md-end">
                                      <h4 className="text-primary text-uppercase fw-bold mb-4">Welcome To ORION Analytics</h4>
                                      <h2 className="display-6 text-uppercase text-white mb-4">Financial Solutions</h2>
                                      <p className="mb-5 fs-5"> We provide Advisory and Analytical solutions to help
                                          your Investment Process
                                      </p>
                                      <div
                                          className="d-flex justify-content-center justify-content-md-end flex-shrink-0 mb-4">
                                          {/*<a className="btn btn-light rounded-pill py-3 px-4 px-md-5 me-2" href="/market_video">*/}
                                            <button
                                              className="btn btn-light rounded-pill py-3 px-4 px-md-5 me-2"
                                              onClick={handleOpenVideo}
                                              style={{ maxWidth: '250px', width: 'auto' }}
                                            >
                                              <i className="fas fa-play-circle me-2"></i> Watch Video
                                            </button>
                                          <a className="btn btn-primary rounded-pill py-3 px-4 px-md-5 ms-2" href="#services_section">Learn
                                              More</a>
                                      </div>

                                      {/* Global Video Modal */}
                                      <VideoModal isOpen={showVideo} onClose={handleCloseVideo} />
                                      <div
                                          className="d-flex align-items-center justify-content-center justify-content-md-end">
                                          <h2 className="text-white me-2">Follow Us:</h2>
                                          <div className="d-flex justify-content-end ms-2">
                                              <a className="btn btn-md-square btn-light rounded-circle me-2" href=""><i
                                                  className="fab fa-facebook-f"></i></a>
                                              <a className="btn btn-md-square btn-light rounded-circle mx-2" href=""><i
                                                  className="fab fa-twitter"></i></a>
                                              <a className="btn btn-md-square btn-light rounded-circle mx-2" href=""><i
                                                  className="fab fa-instagram"></i></a>
                                              <a className="btn btn-md-square btn-light rounded-circle ms-2" href=""><i
                                                  className="fab fa-linkedin-in"></i></a>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>

                </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item style={{height:"550px"}}>
                        <div className="carousel-image-wrapper">

              <img src={carousel2} className="img-fluid w-100" alt="Image"/>
          <div className="overlay"></div> {/* Overlay div */}
        </div>
                <Carousel.Caption>
                      <div className="container">
                          <div className="row g-5">
                              <div className="col-12 animated fadeInUp">
                                  <div className="text-center">
                                      {/*<h4 className="text-primary text-uppercase fw-bold mb-4">Welcome To Orion*/}
                                      {/*    Analytics</h4>*/}
                                      <h2 className="display-6 text-uppercase text-white mb-4">Empowering Financial Decisions with Advanced Analytics and Real-Time Insights</h2>
                                      <p className="mb-5 fs-5">Use our Analytical platforms and Advisory screens to
                                          select stocks and funds. Our Option Strategy screen helps to
                                          monetize unique opportunities available in the market according to your risk
                                          tolerance
                                      </p>
                                      <div className="d-flex justify-content-center flex-shrink-0 mb-4">
                                            <button
                                              className="btn btn-light rounded-pill py-3 px-4 px-md-5 me-2"
                                              onClick={handleOpenVideo}
                                              style={{ maxWidth: '250px', width: 'auto' }}
                                            >
                                              <i className="fas fa-play-circle me-2"></i> Watch Video
                                            </button>
                                          <a className="btn btn-primary rounded-pill py-3 px-4 px-md-5 ms-2" href="#services_section">Learn
                                              More</a>
                                      </div>
                                      {/* Global Video Modal */}
                                      <VideoModal isOpen={showVideo} onClose={handleCloseVideo} />
                                      <div className="d-flex align-items-center justify-content-center">
                                          <h2 className="text-white me-2">Follow Us:</h2>
                                          <div className="d-flex justify-content-end ms-2">
                                              <a className="btn btn-md-square btn-light rounded-circle me-2" href=""><i
                                                  className="fab fa-facebook-f"></i></a>
                                              <a className="btn btn-md-square btn-light rounded-circle mx-2" href=""><i
                                                  className="fab fa-twitter"></i></a>
                                              <a className="btn btn-md-square btn-light rounded-circle mx-2" href=""><i
                                                  className="fab fa-instagram"></i></a>
                                              <a className="btn btn-md-square btn-light rounded-circle ms-2" href=""><i
                                                  className="fab fa-linkedin-in"></i></a>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>

                </Carousel.Caption>
            </Carousel.Item>

            <Carousel.Item style={{height:"550px"}}>
                      <div className="carousel-image-wrapper">

              <img src={carousel1} className="img-fluid w-100" alt="Image"/>
          <div className="overlay"></div> {/* Overlay div */}
        </div>

            <Carousel.Caption>
                      <div className="container">
                          <div className="row g-5">
                              <div className="col-12 animated fadeInUp">
                                  <div className="text-center">
                                      {/*<h4 className="text-primary text-uppercase fw-bold mb-4">Welcome To Orion*/}
                                      {/*    Analytics</h4>*/}
                                      <h2 className="display-6 text-uppercase text-white mb-4">Portfolio and Analytical
                                          Services</h2>
                                      <p className="mb-5 fs-5">Our Portfolio solutions helps to analyze its risks and
                                          performance and various stress scenarios.
                                          Fixed Income analytics platform helps the pricing and risk analysis of complex
                                          instruments.
                                      </p>
                                      <div className="d-flex justify-content-center flex-shrink-0 mb-4">
                                            <button
                                              className="btn btn-light rounded-pill py-3 px-4 px-md-5 me-2"
                                              onClick={handleOpenVideo}
                                              style={{ maxWidth: '250px', width: 'auto' }}
                                            >
                                              <i className="fas fa-play-circle me-2"></i> Watch Video
                                            </button>
                                          <a className="btn btn-primary rounded-pill py-3 px-4 px-md-5 ms-2" href="#services_section">Learn
                                              More</a>
                                      </div>
                                      {/* Global Video Modal */}
                                      <VideoModal isOpen={showVideo} onClose={handleCloseVideo} />
                                      <div className="d-flex align-items-center justify-content-center">
                                          <h2 className="text-white me-2">Follow Us:</h2>
                                          <div className="d-flex justify-content-end ms-2">
                                              <a className="btn btn-md-square btn-light rounded-circle me-2" href=""><i
                                                  className="fab fa-facebook-f"></i></a>
                                              <a className="btn btn-md-square btn-light rounded-circle mx-2" href=""><i
                                                  className="fab fa-twitter"></i></a>
                                              <a className="btn btn-md-square btn-light rounded-circle mx-2" href=""><i
                                                  className="fab fa-instagram"></i></a>
                                              <a className="btn btn-md-square btn-light rounded-circle ms-2" href=""><i
                                                  className="fab fa-linkedin-in"></i></a>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>

    </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    );
}

const watchButtonStyle = {
  padding: '10px 20px',
  fontSize: '16px',
  borderRadius: '8px',
  backgroundColor: '#007bff',
  color: '#fff',
  border: 'none',
  cursor: 'pointer',
};
export default HeaderCarousel;
